<template>
  <div class="grid grid-cols-12 pb-24">
    <div class="col-span-full xl:col-span-10 max-w-10xl w-full order-2 xl:order-1">
      <div v-if="resource.data.length" class="xl:pr-8 pr-0">
        <div class="overflow-hidden shadow ring-1 ring-black ring-opacity-5 rounded-lg">
          <table class="min-w-full divide-y divide-gray-300" scoped="dynamic">
            <thead class="bg-gray-50">
            <tr>
              <slot name="head"/>
              <th
                  v-for="column in columns"
                  :key="column"
                  scope="col"
                  :class="{'flex justify-end': (column === 'Actions' || column === '#') && !preventStyling}"
              >{{ __(column) }}
              </th>
            </tr>
            </thead>
            <tbody class="divide-y divide-gray-200 bg-white">
            <slot :data="resource.data" :icons="icons"/>
            </tbody>
          </table>
        </div>
        <pagination page-key="page" :pagination="resource" v-if="resource.links.length > 3"/>
      </div>
      <slot name="empty" v-else>
        <empty-state
            class="mx-auto xl:pr-8 pr-0"
        >
          <template #title>{{ __('No :resource found', { resource: __(name) }) }}</template>
          <template #description>{{ __('We could not find any resources for your account') }}</template>
        </empty-state>
      </slot>
    </div>
    <div class="col-span-full xl:col-span-2 order-1 xl:order-2">
      <div class="xl:sticky xl:top-0 pb-4">
        <!-- Search / Limiting -->
        <search-input/>
      </div>
    </div>
  </div>
</template>

<script setup>
import {defineComponent, h} from "vue";
import SearchInput from "@/Misc/Table/SearchInput.vue";
import Pagination from "@/Misc/Table/Pagination.vue";
import EmptyState from "@/Misc/EmptyState.vue";

const icons = {
  edit: defineComponent({
    render() {
      return h('svg', {
        width: '20',
        height: '20',
        viewBox: '0 0 20 20',
        fill: 'none',
        xmlns: 'http://www.w3.org/2000/svg'
      }, [
        h('path', {
          d: 'M19 7L19 1M19 1H13M19 1L11 9M8 3H5.8C4.11984 3 3.27976 3 2.63803 3.32698C2.07354 3.6146 1.6146 4.07354 1.32698 4.63803C1 5.27976 1 6.11984 1 7.8V14.2C1 15.8802 1 16.7202 1.32698 17.362C1.6146 17.9265 2.07354 18.3854 2.63803 18.673C3.27976 19 4.11984 19 5.8 19H12.2C13.8802 19 14.7202 19 15.362 18.673C15.9265 18.3854 16.3854 17.9265 16.673 17.362C17 16.7202 17 15.8802 17 14.2V12',
          stroke: 'currentColor',
          'stroke-width': '2',
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round'
        })
      ]);
    }
  }),
  delete: defineComponent({
    render() {
      return h('svg', {
        width: '20',
        height: '22',
        viewBox: '0 0 20 22',
        fill: 'none',
        xmlns: 'http://www.w3.org/2000/svg'
      }, [
        h('path', {
          d: 'M14 5V4.2C14 3.0799 14 2.51984 13.782 2.09202C13.5903 1.71569 13.2843 1.40973 12.908 1.21799C12.4802 1 11.9201 1 10.8 1H9.2C8.07989 1 7.51984 1 7.09202 1.21799C6.71569 1.40973 6.40973 1.71569 6.21799 2.09202C6 2.51984 6 3.0799 6 4.2V5M8 10.5V15.5M12 10.5V15.5M1 5H19M17 5V16.2C17 17.8802 17 18.7202 16.673 19.362C16.3854 19.9265 15.9265 20.3854 15.362 20.673C14.7202 21 13.8802 21 12.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V5',
          stroke: 'currentColor',
          'stroke-width': '2',
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round'
        })
      ]);
    }
  }),
};

defineProps({
  resource: {
    type: Object,
    required: true,
  },
  name: {
    type: String,
    required: true,
  },
  columns: {
    type: Array,
    required: false,
  },
  preventStyling: {
    type: Boolean,
    required: false,
  },
})
</script>
